var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLinkWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.6,
    height: 28.6,
    viewBox: "0 0 28.6 28.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CopyLinkWhiteLogo",
    transform: "translate(-9.7 -9.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M23.04,28.99c0,.19.1.48.1.77a4.729,4.729,0,0,1-1.44,3.46l-1.92,1.92a4.729,4.729,0,0,1-3.46,1.44,4.921,4.921,0,0,1-4.9-4.9,4.729,4.729,0,0,1,1.44-3.46l1.92-1.92a4.729,4.729,0,0,1,3.46-1.44,2.045,2.045,0,0,1,.77.1l1.44-1.44a5.592,5.592,0,0,0-2.21-.38,6.5,6.5,0,0,0-4.7,1.92l-1.92,1.92a6.5,6.5,0,0,0-1.92,4.7,6.628,6.628,0,0,0,6.62,6.62,6.5,6.5,0,0,0,4.7-1.92l1.92-1.92a6.5,6.5,0,0,0,1.92-4.7,5.592,5.592,0,0,0-.38-2.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M31.68,9.7a6.5,6.5,0,0,0-4.7,1.92l-1.92,1.92a6.5,6.5,0,0,0-1.92,4.7,5.592,5.592,0,0,0,.38,2.21l1.44-1.44c0-.19-.1-.48-.1-.77a4.729,4.729,0,0,1,1.44-3.46l1.92-1.92a4.729,4.729,0,0,1,3.46-1.44,4.921,4.921,0,0,1,4.9,4.9,4.729,4.729,0,0,1-1.44,3.46L33.22,21.7a4.729,4.729,0,0,1-3.46,1.44,2.045,2.045,0,0,1-.77-.1l-1.44,1.44a5.592,5.592,0,0,0,2.21.38,6.5,6.5,0,0,0,4.7-1.92l1.92-1.92a6.5,6.5,0,0,0,1.92-4.7A6.628,6.628,0,0,0,31.68,9.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.2,29.76a.87.87,0,0,1-.67-.29.914.914,0,0,1,0-1.34l9.6-9.6a.948.948,0,1,1,1.34,1.34l-9.6,9.6A.87.87,0,0,1,19.2,29.76Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkWhiteLogo);
export default __webpack_public_path__ + "static/media/CopyLinkWhiteLogo.b3d7e0184e6cd627788142cf49c14681.svg";
export { ForwardRef as ReactComponent };